import { render, staticRenderFns } from "./TrailerAudioExtractor.vue?vue&type=template&id=a893223e&"
import script from "./TrailerAudioExtractor.vue?vue&type=script&lang=js&"
export * from "./TrailerAudioExtractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports